import "./index.css";
import GdnAdTemplate from "../GdnAdTemplate";

/**
 * Google Display Network — 468×60 leaderboard (rendered @2× = 936×120).
 * Icon-only logo on the left, title + subtitle on the right; shared body in
 * ../GdnAdTemplate.
 */
const Leaderboard468Ads = ({id, zoom}) => <GdnAdTemplate id={id} zoom={zoom} variant="icon" />;

export default Leaderboard468Ads;
